"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetCustomerSources = void 0;
var HttpClient_1 = require("../core/HttpClient");
var GetCustomerSources = function () {
    return HttpClient_1.HttpClient.get("/marketing/reports/customer-sources");
};
exports.GetCustomerSources = GetCustomerSources;
